import { render } from "./EditYoutubeChannel.vue?vue&type=template&id=21577f06&scoped=true"
import script from "./EditYoutubeChannel.vue?vue&type=script&lang=js"
export * from "./EditYoutubeChannel.vue?vue&type=script&lang=js"

import "./EditYoutubeChannel.vue?vue&type=style&index=0&id=21577f06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21577f06"]])

export default __exports__